"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __exportStar = (this && this.__exportStar) || function(m, exports) {
    for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(exports, p)) __createBinding(exports, m, p);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ThemedParagraph = exports.ThemedSpan = exports.ThemedAnchor = exports.ThemedHeading = void 0;
const react_1 = __importDefault(require("react"));
const styles_1 = require("./styles");
const ThemedHeading = (props) => {
    const { children, headingLevel } = props;
    switch (headingLevel) {
        case 1:
            return react_1.default.createElement(styles_1.ThemedH1, Object.assign({}, props), children);
        case 2:
            return react_1.default.createElement(styles_1.ThemedH2, Object.assign({}, props), children);
        case 3:
            return react_1.default.createElement(styles_1.ThemedH3, Object.assign({}, props), children);
        case 4:
            return react_1.default.createElement(styles_1.ThemedH4, Object.assign({}, props), children);
        case 5:
            return react_1.default.createElement(styles_1.ThemedH5, Object.assign({}, props), children);
        case 6:
            return react_1.default.createElement(styles_1.ThemedH6, Object.assign({}, props), children);
        default:
            return react_1.default.createElement(styles_1.ThemedH1, Object.assign({}, props), children);
    }
};
exports.ThemedHeading = ThemedHeading;
const ThemedAnchor = (props) => {
    const { color = 'link' } = props, rest = __rest(props, ["color"]);
    return (react_1.default.createElement(styles_1.ThemedA, Object.assign({}, rest, { color: color }), props.children));
};
exports.ThemedAnchor = ThemedAnchor;
var styles_2 = require("./styles");
Object.defineProperty(exports, "ThemedSpan", { enumerable: true, get: function () { return styles_2.ThemedSpan; } });
Object.defineProperty(exports, "ThemedParagraph", { enumerable: true, get: function () { return styles_2.ThemedParagraph; } });
__exportStar(require("./types"), exports);
